import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ServiceDataList } from 'src/app/components/massive/models/serviceDataList.model';
import { Service } from 'src/app/components/massive/models/services.model';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { TableColumn } from 'src/app/components/shared/types/tableColumn.type';
import { MassiveServiceFlags } from '../../massive-services.flags';
import { Filters } from 'src/app/components/shared/types/filters.type';
import { ServicesFilters } from 'src/app/components/massive/models/servicesFilters.model';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { TableEditingActionsTypes } from 'src/app/components/shared/sharedModules/designSystem/models/tableEditingActionsTypes.enum';
import { TableOption } from 'src/app/components/massive/models/tableOption.interface';

@Component({
  selector: 'app-massive-services-table',
  templateUrl: './services-table.component.html',
  styleUrls: ['./services-table.component.sass'],
})
export class ServicesTableComponent {
  @Input() dataList: ServiceDataList;
  @Input() flags: Flags<MassiveServiceFlags>;
  @Input() filters: Filters<ServicesFilters>;
  @Input() tableListColumns: TableColumn<Service, ServicesFilters>[];
  @Input() tableOptionList: TableOption[] = [];
  @Input() actions: Actions<TableEditingActionsTypes, Service>;
  @Output() rowActionEvent = new EventEmitter<string>();

  massiveServiceFlags = MassiveServiceFlags;

  constructor() {
    /** */
  }

  /**
   * Emit event when row is clicked
   */
  ownRowActionEvent(serviceId: string): void {
    this.rowActionEvent.emit(serviceId);
  }
}
